const GOOGLE_CLIENT_ID =
  '411380325312-8lssceu6ggf5t5k35mhgd6dpcl374tbq.apps.googleusercontent.com';

let callbackRef = null;
let initialized = false;

function waitForGoogle() {
  return new Promise((resolve) => {
    if (window.google?.accounts?.id) {
      resolve();
      return;
    }
    const interval = setInterval(() => {
      if (window.google?.accounts?.id) {
        clearInterval(interval);
        resolve();
      }
    }, 50);
  });
}

export function setGoogleSignInCallback(callback) {
  callbackRef = callback;
}

export async function ensureGoogleSignInInitialized() {
  await waitForGoogle();
  if (initialized) return;

  window.google.accounts.id.initialize({
    client_id: GOOGLE_CLIENT_ID,
    callback: (response) => callbackRef?.(response),
    auto_select: false,
    cancel_on_tap_outside: true,
  });
  initialized = true;
}

function buttonWidth(container) {
  const measured = container?.offsetWidth || container?.parentElement?.offsetWidth || 400;
  return Math.min(400, Math.max(200, measured));
}

export async function renderGoogleSignInButton(container, { text = 'signin_with' } = {}) {
  if (!container) return;

  await ensureGoogleSignInInitialized();
  container.innerHTML = '';

  window.google.accounts.id.renderButton(container, {
    theme: 'outline',
    size: 'large',
    width: buttonWidth(container),
    text,
    shape: 'rectangular',
  });
}
